import { render, staticRenderFns } from "./OptionsMenu.vue?vue&type=template&id=1fdd584a"
import script from "./OptionsMenu.vue?vue&type=script&lang=ts"
export * from "./OptionsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports